/*
|--------------------------------------------------------------------------
| ROLES
|--------------------------------------------------------------------------
*/

export const ROLES = {
  ADMIN: "ADMIN",
  SALES: "SALES",
  AGENT: "AGENT",
};


/*
|--------------------------------------------------------------------------
| MANAGEABLE ROLES
|--------------------------------------------------------------------------
|
| Admin can create/manage these users.
|
*/

export const MANAGEABLE_ROLES = [
  ROLES.SALES,
  ROLES.AGENT,
];


/*
|--------------------------------------------------------------------------
| USER STATUS
|--------------------------------------------------------------------------
*/

export const USER_STATUS = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  SUSPENDED: "SUSPENDED",
};


/*
|--------------------------------------------------------------------------
| USER STATUS LABELS
|--------------------------------------------------------------------------
*/

export const USER_STATUS_LABELS = {
  [USER_STATUS.ACTIVE]: "Active",
  [USER_STATUS.INACTIVE]: "Inactive",
  [USER_STATUS.SUSPENDED]: "Suspended",
};


/*
|--------------------------------------------------------------------------
| ROLE LABELS
|--------------------------------------------------------------------------
*/

export const ROLE_LABELS = {
  [ROLES.ADMIN]: "Administrator",
  [ROLES.SALES]: "Sales",
  [ROLES.AGENT]: "Agent",
};


/*
|--------------------------------------------------------------------------
| USER FORM DEFAULTS
|--------------------------------------------------------------------------
*/

export const DEFAULT_USER_FORM = {
  name: "",
  email: "",
  phone: "",
  password: "",
  role: "",
};


/*
|--------------------------------------------------------------------------
| UPDATE FORM DEFAULTS
|--------------------------------------------------------------------------
*/

export const DEFAULT_UPDATE_USER_FORM = {
  name: "",
  email: "",
  phone: "",
};


/*
|--------------------------------------------------------------------------
| PASSWORD FORM DEFAULTS
|--------------------------------------------------------------------------
*/

export const DEFAULT_PASSWORD_FORM = {
  newPassword: "",
  confirmPassword: "",
};